import React from "react";
import { Link } from "react-router-dom";

function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-indigo-700 mb-2">
            Geothara Privacy Policy
          </h1>
          <p className="text-gray-600 italic">Last Updated: Jan 25, 2025</p>
        </div>

        <div className="bg-white shadow-lg rounded-lg overflow-hidden">
          <div className="p-8">
            <p className="text-gray-600 mb-8">
              We respect your privacy and are committed to protecting your
              personal information. This Privacy Policy explains how we collect,
              use, and safeguard your data when you visit our website.
            </p>

            {/* Information We Collect */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
                1. Information We Collect
              </h2>
              <ul className="space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="font-medium mr-2">Personal Data:</span>
                  <span>
                    We may collect your name, email address, or other
                    information you provide when filling out forms or
                    registering.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-medium mr-2">Location Data:</span>
                  <span>
                    If you permit, we collect your location using the
                    Geolocation API for personalized services.
                  </span>
                </li>
                <li className="flex items-start">
                  <span className="font-medium mr-2">Technical Data:</span>
                  <span>
                    We collect IP addresses, browser type, device information,
                    and usage data to improve website functionality and
                    security.
                  </span>
                </li>
              </ul>
            </section>

            {/* How We Use Your Data */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
                2. How We Use Your Data
              </h2>
              <p className="text-gray-600 mb-2">We use your data to:</p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 ml-4">
                <li>Provide and improve our services</li>
                <li>Personalize your experience</li>
                <li>Communicate with you about updates or inquiries</li>
                <li>
                  Ensure website security and compliance with legal obligations
                </li>
              </ul>
            </section>

            {/* Sharing Your Information */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
                3. Sharing Your Information
              </h2>
              <p className="text-gray-600 mb-2">
                We do not sell or rent your personal data. Your information may
                be shared with trusted third-party service providers for the
                following purposes:
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-600 ml-4">
                <li>Hosting and website maintenance</li>
                <li>Analytics to improve our services</li>
              </ul>
              <p className="text-gray-600 mt-2">
                All third parties are bound to strict data protection
                agreements.
              </p>
            </section>

            {/* Contact Information */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-indigo-700 mb-4">
                8. Contact Us
              </h2>
              <div className="bg-gray-50 rounded-lg p-6">
                <p className="text-gray-600 mb-4">
                  If you have questions or concerns about this Privacy Policy,
                  please contact us at:
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-center">
                    <i className="fas fa-envelope text-indigo-600 w-6"></i>
                    <span>contact@geothara.com</span>
                  </li>
                  <li className="flex items-center">
                    <i className="fas fa-phone text-indigo-600 w-6"></i>
                    <span>+1-424-535-8034</span>
                  </li>
                  <li className="flex items-center">
                    <i className="fas fa-map-marker-alt text-indigo-600 w-6"></i>
                    <span>
                      3220, Apt 202, Sawtelle Blvd, Los Angeles, 90066
                    </span>
                  </li>
                </ul>
              </div>
            </section>

            <div className="border-t border-gray-200 pt-8 mt-8 text-center">
              <p className="text-gray-600 mb-6">
                By using our website, you agree to this Privacy Policy. We
                reserve the right to update this policy at any time. Please
                review it periodically for changes.
              </p>
              <Link
                to="/"
                className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                <i className="fas fa-arrow-left mr-2"></i>
                Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
